<template>
  <div class="sm-customers__top-import">
    <h3>Import users</h3>
    <upload-csv
      @upload="$event => file = $event"
      @delete="file = null"
    />
    <template v-if="!file">
      <p class="sm-txt-strong">Requirements</p>
      <ul>
        <li
          v-for="req in requirementsList"
          :key="req"
        >{{req}}</li>
      </ul>
      <a
        :href="sampleUrl"
        class="sm-sys"
      >
        <include-svg :name="'icon-download2'" />
        <span>Get a sample .csv file</span>
      </a>
    </template>
    <btn-block
      v-else
      :text="'Confirm upload'"
      @click="$emit('upload', file)"
    />
  </div>
</template>

<script>
import UploadCSV from '@/components/UploadCSV';
import Urls from '@/settings/urls';

export default {
  name: 'import-customers',
  components: {
    'upload-csv': UploadCSV
  },
  data() {
    return {
      file: null,
      requirementsList: [
        'The file must be in .csv format and cannot be larger than 5 MB',
        'First line of .csv file must contain these columns – Name, Email, Phone, Street, City, State/Province, Zip/Postal code, Country.',
        'Optional columns – Company name'
      ],
      sampleUrl: Urls.links.csv_sample
    }
  }
}
</script>